<template>
  <div>
    <el-form label-position="top" ref="rcform" :model="data" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="rc_name" label="责任链名称">
            <el-input v-model="data.rc_name" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="rc_defn" label="责任链标识">
            <el-input v-model="data.rc_defn" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="rc_desc" label="责任链描述">
            <el-input type="textarea" v-model="data.rc_desc"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <Panel title="组件列表">
      <template slot="buttons">
        <el-button
          title="添加组件"
          class="green"
          @click="handleAddRcCom"
          icon="el-icon-fa-plus"
          :disabled="!data.uuid"
          >添加组件
        </el-button>
        <el-button
          title="删除组件"
          class="red"
          @click="handleMultiDeleteRcCom"
          icon="el-icon-fa-trash"
          :disabled="!data.uuid"
          >删除组件
        </el-button>
      </template>
      <el-table
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
        ref="dataTable"
        :data="table.comList"
        height="250"
        v-loading="table.loading"
      >
        <el-table-column
          type="selection"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="rc_order"
          label="执行顺序"
          show-overflow-tooltip
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cm_name"
          label="系统组件"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cm_class"
          label="组件实现类"
          width="300"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tooltip effect="dark" placement="top" :content="row.cm_class">
              <span>{{
                row.cm_class.substr(row.cm_class.lastIndexOf('.') + 1)
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="cm_conf"
          label="组件配置"
          width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover placement="top" trigger="click">
              <div>
                {{ JSON.stringify(JSON.parse(scope.row.cm_conf), null, 4) }}
              </div>
              <el-button
                title="点击查看"
                class="blue"
                slot="reference"
                icon="el-icon-fa-eye"
                >点击查看</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button
              title="编辑"
              class="blue"
              @click="handleEditRcCom(scope.row)"
              icon="el-icon-fa-edit"
              >编辑</el-button
            >
            <el-button
              title="删除"
              class="red"
              @click="doDeleteRcCom(scope.row)"
              icon="el-icon-fa-trash"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </Panel>

    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :title="comEditor.uuid ? '编辑' : '添加' + '责任链组件'"
      width="600px"
      :visible.sync="comEditor.visible"
    >
      <div class="dialog-button">
        <el-button
          title="保存组件"
          class="blue"
          icon="el-icon-fa-save"
          v-loading="comEditor.loading"
          @click="handleSaveRcCom()"
          >保存
        </el-button>
      </div>
      <div v-if="comEditor.visible" v-loading="comEditor.loading">
        <RcComEditor
          v-if="comEditor.visible"
          ref="RcComEditorRef"
          v-model="comEditor.data"
          :orderIncrement="table.comList.length + 1"
          @refresh="
            () => {
              this.queryRcCom();
              comEditor.visible = false;
            }
          "
          @loading="(v) => (comEditor.loading = v)"
        ></RcComEditor>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RcComEditor from './RcComEditor';
import RcApi from './Rc';
import Validate from '@/libs/Validate';

let defaultData = {
  rc_name: '',
  rc_defn: '',
  rc_desc: '',
};
export default {
  components: { RcComEditor },
  props: {
    value: Object,
  },
  data() {
    return {
      data: {
        uuid: '',
        rc_name: '',
        rc_defn: '',
        rc_desc: '',
      },
      table: {
        comList: [],
        loading: false,
      },
      comEditor: {
        uuid: null,
        visible: false,
        loading: false,
        data: {},
      },

      comSysList: [],

      multipleSelection: [],
      rules: {
        rc_name: [
          { required: true, message: '这是必填字段' },
          { validator: Validate.checkSpecificKey, trigger: ['blur', 'change'] },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符以内',
            trigger: 'blur',
          },
        ],
        rc_defn: [
          { required: true, message: '这是必填字段' },
          { validator: Validate.checkSpecificKey, trigger: ['blur', 'change'] },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符以内',
            trigger: 'blur',
          },
        ],
        // rc_desc: [
        //   { validator: Validate.checkSpecificKey, trigger: ['blur', 'change'] },
        //   {
        //     min: 0,
        //     max: 200,
        //     message: '长度在 0 到 200 个字符以内',
        //     trigger: 'blur',
        //   },
        // ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async handleSaveRc() {
      await this.$refs.rcform.validate();
      if (this.data.uuid) {
        await RcApi.updateRpbChain(this.data);
      } else {
        let resp = await RcApi.saveRpbChain(this.data);
        this.$set(this.data, 'uuid', resp.rc_uuid);
      }
      this.$emit('refresh');
    },
    async handleMultiDeleteRcCom() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择数据！');
        return;
      }
      try {
        await this.confirm();
        this.table.loading = true;
        let array = this.multipleSelection.map((value) => value.rccom_uuid);
        await RcApi.delRcCom(array);
        await this.queryRcCom();
      } finally {
        this.table.loading = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async doDeleteRcCom(rowData) {
      try {
        await this.confirm();
        this.table.loading = true;
        await RcApi.delRcCom([rowData.rccom_uuid]);
        await this.queryRcCom();
      } finally {
        this.table.loading = false;
      }
    },
    handleAddRcCom() {
      this.comEditor.data = { rc_uuid: this.data.uuid };
      this.comEditor.visible = true;
    },
    handleEditRcCom(row) {
      this.comEditor.data = row;
      this.comEditor.data.rc_uuid = this.data.uuid;
      this.comEditor.visible = true;
    },
    handleSaveRcCom() {
      this.$refs.RcComEditorRef.handleSaveRcCom();
    },
    async queryRcCom() {
      try {
        this.table.loading = true;
        let resp = await RcApi.getRcCom(this.data.uuid);
        this.table.comList = resp.datas;
      } finally {
        this.table.loading = false;
      }
    },
    init() {
      if (this.value.uuid) {
        this.data = {
          uuid: this.value.uuid,
          rc_name: this.value.rcname,
          rc_defn: this.value.rcdefn,
          rc_desc: this.value.rcdesc,
        };
        this.queryRcCom();
      }
    },
  },
};
</script>
